import React from 'react';
import { TILE_COLORS, codeToChar } from '../VestaboardCard';

// 3x15 Vestaboard Note grid styled like the board (black bezel, split-flap tiles, colour chips).
export const NoteGrid = ({ matrix, size = 'md', testid }) => {
  const cell = size === 'lg' ? 'w-[34px] h-[46px] text-lg' : size === 'sm' ? 'w-[11px] h-[15px] text-[7px]' : 'w-[18px] h-[24px] text-xs';
  const rows = (matrix && matrix.length ? matrix : [[], [], []]).map(r => (r && r.length ? r : Array(15).fill(0)));
  return (
    <div className={`inline-flex flex-col ${size === 'lg' ? 'gap-[4px] p-4 rounded-md' : 'gap-[2px] p-2 rounded'} bg-[#0b0b0b] border border-neutral-800 shadow-[inset_0_0_30px_rgba(0,0,0,0.8)]`} data-testid={testid}>
      {rows.map((codes, i) => (
        <div key={i} className={`flex ${size === 'lg' ? 'gap-[4px]' : 'gap-[2px]'}`}>
          {codes.map((code, j) => {
            const chip = TILE_COLORS[code];
            const heart = code === 62;
            return (
              <span key={j} style={chip ? { background: chip } : undefined}
                className={`${cell} flex items-center justify-center rounded-[2px] font-mono leading-none ${chip ? '' : 'bg-neutral-900 text-neutral-100 shadow-[inset_0_-1px_0_rgba(255,255,255,0.06)]'} ${heart ? 'text-red-400' : ''}`}>
                {chip ? '' : heart ? '♥' : (codeToChar(code) || '\u00A0')}
              </span>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export const fmtDT = (iso) => iso ? new Date(iso).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';
export const fmtTime = (iso) => iso ? new Date(iso).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) : '—';
export const DAYS = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
export const REASON_LABEL = { rotation: 'Rotation', event: 'Event', manual: 'Push', simulate: 'Simulation', scheduled: 'geplant' };
export const minutesLabel = (s) => (s >= 3600 ? `${Math.round(s / 360) / 10} h` : s >= 60 ? `${Math.round(s / 60)} Min` : `${s} s`);
